import { ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useId } from '../../../common/hooks/useId';
import { OVERLAY_ANIMATION_DURATION } from '../../constants';
import { useOverlay, OverlayInput } from '../overlay/OverlayContext';
import { FilterPill } from './FilterPill';

export interface OverlayFilterPillProps {
  hasValue: boolean;
  trackingId?: LinkId;
  caption: string;
  content: ReactNode;
  onClear: VoidFunction;
  fixedMobileHeight?: boolean;
  initiallyActive?: boolean;
  filterIcon?: boolean;
  appliedFilterCount?: number;
}

export const OverlayFilterPill = ({
  hasValue,
  caption,
  content,
  trackingId,
  onClear,
  fixedMobileHeight,
  initiallyActive,
  filterIcon,
  appliedFilterCount,
}: OverlayFilterPillProps) => {
  const id = useId();
  const { activeId, activate, clear } = useOverlay();
  const isActive = activeId === id;

  const onActivate = (x: number, y: number): void => {
    activate(id, x, y, fixedMobileHeight);
  };

  return (
    <>
      <FilterPill
        appliedFilterCount={appliedFilterCount}
        filterIcon={filterIcon}
        dropdown={!hasValue}
        hasValue={hasValue}
        trackingId={trackingId}
        onClick={isActive ? clear : onActivate}
        selected={isActive}
        initiallyActive={initiallyActive}
        onClear={() => {
          onClear();
          clear();
        }}
      >
        {caption}
      </FilterPill>

      <CSSTransition in={isActive} unmountOnExit timeout={OVERLAY_ANIMATION_DURATION}>
        <OverlayInput>{content}</OverlayInput>
      </CSSTransition>
    </>
  );
};
